import { Base64 } from 'js-base64';
import MD5 from 'md5';

// ─── 设备 ID ──────────────────────────────────────────────────────────────────

/** 获取（或生成并缓存）唯一设备 ID */
export function getDeviceID(): string {
  let deviceId = localStorage.getItem('device_id');
  if (!deviceId) {
    deviceId = `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
    localStorage.setItem('device_id', deviceId);
  }
  return deviceId;
}

// ─── 客户端 IP ────────────────────────────────────────────────────────────────

/** 尝试通过 ipinfo.io 获取客户端公网 IP，失败时返回 '0.0.0.0' */
export async function getClientIP(): Promise<string> {
  try {
    const res = await fetch('https://ipinfo.io/json');
    const data = await res.json();
    return data.ip ?? '0.0.0.0';
  } catch {
    return '0.0.0.0';
  }
}

// ─── 数据加密 ─────────────────────────────────────────────────────────────────

/**
 * encodeSand：对敏感字段（手机号、邮箱）进行混淆加密。
 * 与后端约定的加密算法，需与 robo-platform 保持一致。
 *
 * @param strSecKey - 密钥（通常为 device_id）
 * @param strData   - 待加密数据（手机号 / 邮箱）
 * @param intTm     - 时间戳字符串
 * @returns { key: timestamp, auth: encryptedString }
 */
export function encodeSand(
  strSecKey: string,
  strData: string,
  intTm: string,
): { key: string; auth: string } {
  const strBase64 = Base64.encode(strData);
  const intDataLen = strBase64.length;

  let strMd5Part1 = MD5(strSecKey + strBase64 + intTm);
  while (intDataLen > strMd5Part1.length) {
    strMd5Part1 += strMd5Part1;
  }
  strMd5Part1 = strMd5Part1.substring(0, intDataLen);

  let strMd5Part2 = MD5(strSecKey + strMd5Part1 + intTm);
  const arrMd5Part2 = strMd5Part2.split('');

  for (let i = 0; i < intDataLen; i++) {
    const pos = strMd5Part1.charCodeAt(i) % 32;
    arrMd5Part2.splice(pos, 0, strBase64[i]);
  }
  strMd5Part2 = arrMd5Part2.join('');

  return {
    key: intTm,
    auth: (strMd5Part1 + strMd5Part2).trim(),
  };
}
